import React from 'react';
import {motion} from 'framer-motion';
import {useAuth} from '../context/AuthContext';
import {useNavigate} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCloud, FiLogOut, FiSettings, FiUser}=FiIcons;

function Header() {
  const {user, logout}=useAuth();
  const navigate=useNavigate();

  const handleLogout=()=> {
    logout();
    navigate('/login');
  };

  const handleAdminPanel=()=> {
    navigate('/admin');
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <motion.div className="flex items-center space-x-3" initial={{opacity: 0, x: -20}} animate={{opacity: 1, x: 0}}>
            <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-lg">
              <SafeIcon icon={FiCloud} className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">MinterMark Image Portal</h1>
              <p className="text-sm text-gray-500">Secure image management</p>
            </div>
          </motion.div>
          
          <motion.div className="flex items-center space-x-4" initial={{opacity: 0, x: 20}} animate={{opacity: 1, x: 0}}>
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full">
                <SafeIcon icon={FiUser} className="w-4 h-4 text-gray-600" />
              </div>
              <div className="hidden sm:block">
                <p className="text-sm font-medium text-gray-900">{user.name}</p>
                <p className="text-xs text-gray-500 capitalize">{user.role}</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              {user.role === 'admin' && (
                <motion.button whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} onClick={handleAdminPanel} className="p-2 text-gray-500 hover:text-gray-700 rounded-lg hover:bg-gray-100 transition-colors" title="Admin Panel">
                  <SafeIcon icon={FiSettings} className="w-5 h-5" />
                </motion.button>
              )}
              <motion.button whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} onClick={handleLogout} className="p-2 text-gray-500 hover:text-red-600 rounded-lg hover:bg-red-50 transition-colors" title="Logout">
                <SafeIcon icon={FiLogOut} className="w-5 h-5" />
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>
    </header>
  );
}

export default Header;